module.exports = __webpack_public_path__ + "img/info.f85272d7.svg";